<app-icon name="info"
          size="xs"
          [tooltip]="tooltipText()"
          placement="right" />
